<div style="margin: 20px;">

  <ng-container>
    <div class="box-container mb-3">
      <div class="box-header">
        <span>{{ 'shared.details' | translate }}</span>
      </div>
      <div class="box-item">
        <span class="text-blue-color me-2">{{ 'links.unique_links_label' | translate }}:</span>
        <span *ngIf="!isAnalyzing">{{ uniqueLinks?.size || 0 }} <span *ngIf="linksIncomplete">({{ 'analysis.partial' | translate }})</span></span>
        <span *ngIf="isAnalyzing">{{ 'shared.computing' | translate }}</span>
      </div>

      <div class="box-item">
        <span class="text-blue-color me-2">{{ 'links.unique_qr_codes_label' | translate }}:</span>
        <span *ngIf="!isAnalyzing">{{ uniqueQrCodes?.size || 0 }} <span *ngIf="qrIncomplete">({{ 'analysis.partial' | translate }})</span></span>
        <span *ngIf="isAnalyzing">{{ 'shared.computing' | translate }}</span>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="uniqueQrCodes?.size > 0">
    <div *ngFor="let qrCode of uniqueQrCodes | keyvalue : keyValueComparatorQrCodes ;let  i = index "
         class="box-container">
      <div class="box-header d-flex">
        <div class="label">{{ (qrCode.value.qrCodeDeceptiveLink ? 'links.deceptive_qr_code_to' : 'links.qr_code_to' ) | translate }}:</div>
        <span class="domain" [matTooltip]="getDomainFromLink(qrCode, EvaluationFlowsEnum.QRCODE)">
            {{ getDomainFromLink(qrCode, EvaluationFlowsEnum.QRCODE) }}
          </span>
      </div>
      <div [id]="'qrCodeSecure-'+qrCode.value.decoded">
        <div class="box-item">
          <span class="text-blue-color">{{ 'links.link_address' | translate }}: </span>
        </div>

        <div class="box-item" (mouseenter)="qrCode.value.isHovering = !qrCode.value.isHovering"
             (mouseleave)="qrCode.value.isHovering = !qrCode.value.isHovering">
          <span class="ellipsis" [matTooltip]="qrCode.value.decoded">{{ qrCode.value.decoded }}</span>
        </div>

        <div *ngIf="qrCode.value.isHovering" class="box-item justify-content-center">
          <img src="{{qrCode.value.qr_code}}" class="hover-image" />
        </div>

      </div>

      <div [id]="'qrCodeTrusted-'+qrCode.value.decoded" class="box-item">
        <span class="text-blue-color me-2">{{ 'links.in_trusted_domain_list' | translate }}: </span>
        <span [ngClass]="{'text-green-2-color': qrCode.value.trusted, 'red': !qrCode.value.trusted}">
          {{ qrCode.value.trusted ? ('shared.yes' | translate) : ('shared.no' | translate) }}

        </span>
      </div>

      <div class="box-item">
        <span class="text-blue-color me-2">{{ 'links.link_domain_age' | translate }}: </span>
        <ng-container *ngIf="qrCode.value.domainAge == undefined">
            <span class="text-orange-color d-flex align-items-center">
              {{ 'links.not_checked' | translate }}
            </span>
        </ng-container>

        <ng-container *ngIf="qrCode.value.domainAge">
          <span [ngClass]="getDomainAgeColor(qrCode.value.isDomainNew)">
            {{ qrCode.value.domainAge }}
          </span>
        </ng-container>

        <button *ngIf="qrCode.value.domainAge == undefined || qrCode.value.domainAge == Constants.FAILED_DOMAIN_AGE"
                [disabled]="isRetrievingQrCodeLinkAge[i]" class="ms-2" mat-raised-button
                (click)="retrieveDomainAge(EvaluationFlowsEnum.QRCODE, qrCode.key, qrCode.value, i, isRetrievingQrCodeLinkAge)">{{ 'links.check' | translate }}
        </button>
        <mat-progress-spinner class="ms-1" diameter="20" color="primary" mode="indeterminate"
                              *ngIf="isRetrievingQrCodeLinkAge[i]">
        </mat-progress-spinner>

      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="uniqueLinks?.size > 0">
    <div *ngFor="let link of uniqueLinks | keyvalue : keyValueComparator ;let  i = index " class="box-container">
      <div class="box-header d-flex">
        <div class="label">{{ (link.value.deceptiveLink ? 'links.deceptive_link_to' : 'links.link_to') | translate }}:</div>
        <span class="domain" [matTooltip]="getDomainFromLink(link, EvaluationFlowsEnum.LINKS)">
            {{ getDomainFromLink(link, EvaluationFlowsEnum.LINKS) }}
        </span>
      </div>
      <div [id]="'linkSecure-'+link.key">
        <div class="box-item">
          <span class="text-blue-color">{{ 'links.link_address' | translate }}: </span>
        </div>
        <div class="box-item">
          <span class="ellipsis" [matTooltip]="link.key">{{ link.key }}</span>
        </div>
      </div>

      <div [id]="'linkClear-'+link.key" class="box-item" style="display: block !important;">
        <span class="text-blue-color me-2">{{ 'links.displayed_in_thread_as' | translate }}: </span>
        <div class="ms-4">
          <ul>
            <li *ngFor="let linkDisplay of link.value.displayedAs">
                <span (mouseenter)="linkDisplay.isHovering = !linkDisplay.isHovering"
                      (mouseleave)="linkDisplay.isHovering = !linkDisplay.isHovering"
                      [attr.style]="getLinkDisplayStyle(linkDisplay)">
                  {{ linkDisplay.displayedAs }}
                </span>
              <div *ngIf="linkDisplay.isHovering && linkDisplay.imgUrl" class="box-item justify-content-center">
                <img src="{{linkDisplay.imgUrl}}" class="hover-image" />
              </div>
            </li>
          </ul>
        </div>
      </div>

      <div [id]="'linkIsConditional-' + link.key" class="box-item" *ngIf="link.value.linkIsConditional">
        <span class="red"> {{"links.conditional_link" | translate}} </span>
      </div>

      <div [id]="'linkTrusted-'+link.key" class="box-item">
        <span class="text-blue-color me-2">{{ 'links.in_trusted_domain_list' | translate }}: </span>
        <span [ngClass]="{'text-green-2-color': link.value.trusted, 'red': !link.value.trusted}">
          {{ link.value.trusted ? ('shared.yes' | translate) : ('shared.no' | translate) }}
        </span>
      </div>

      <div class="box-item">
        <span class="text-blue-color me-2">{{ 'links.link_domain_age' | translate }}: </span>
        <ng-container *ngIf="link.value.domainAge == undefined">
          <span class="text-orange-color d-flex align-items-center">
            {{ 'links.not_checked' | translate }}
          </span>
        </ng-container>

        <ng-container *ngIf="link.value.domainAge">
            <span [ngClass]="getDomainAgeColor(link.value.isDomainNew)">
              {{ link.value.domainAge }}
            </span>
        </ng-container>

        <button *ngIf="link.value.domainAge == undefined || link.value.domainAge == Constants.FAILED_DOMAIN_AGE"
                [disabled]="isRetrievingAge[i]" class="ms-2" mat-raised-button
                (click)="retrieveDomainAge(EvaluationFlowsEnum.LINKS, link.key, link.value, i, isRetrievingAge)">{{ 'links.check' | translate }}
        </button>
        <mat-progress-spinner class="ms-1" diameter="20" color="primary" mode="indeterminate"
                              *ngIf="isRetrievingAge[i]">
        </mat-progress-spinner>
      </div>
    </div>
  </ng-container>
</div>
